import React, { Fragment } from 'react';
import { Intro, PagerButton } from 'dea-core';
import img from '../../assets/images/introduction-group.png';

export default {
  title: 'The Opioid Epidemic',
  path: '/engage/opioid-epidemic',
  content: (
    <Fragment>
      <Intro
        img={img}
        title={'The Opioid Epidemic'}
        lead="You’ll meet Jason and Carrie, both in recovery from opioid substance misuse disorder, to gain a real-life perspective on the epidemic. And, you’ll meet Gail, a prevention specialist."
      />
      <section>
        <div>
          <h2 className={'no-margin'}>Jason Cox</h2>
          <p>
            He was in active addiction for over 15 years and now works to help
            people seeking resources and support through an opioid substance use
            disorder.
          </p>
        </div>
        <div>
          <h2 className={'no-margin'}>Carrie Parnell</h2>
          <p>
            She was in active addiction for over 17 years and now works in
            coordinating a recovery support program that helps people
            experiencing an opioid substance use disorder.
          </p>
        </div>
        <div>
          <h2 className={'no-margin'}>Gail M. Taylor</h2>
          <p>
            M.ED. Director of the Office of Behavioral Health and Wellness for
            the Virginia Department of Behavioral Health and Developmental
            Services.
          </p>
        </div>
      </section>
      <PagerButton />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/engage/TheOpioidEpidemic.js